/* eslint-disable */
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB-9R_6zhFpz5AgoN8gY7v_p4KMBXAmuio",
    authDomain: "rm-ecommerce.firebaseapp.com",
    projectId: "rm-ecommerce",
    storageBucket: "rm-ecommerce.firebasestorage.app",
    messagingSenderId: "730032594931",
    appId: "1:730032594931:web:a6e3812a8a6153e78ffc86",
    databaseURL: "https://rm-ecommerce-default-rtdb.europe-west1.firebasedatabase.app/",
    measurementId: "G-TCGVNRKNLG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

export default db;
export { auth, storage };